import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { PlatformProvider } from "./lib/bootstrap.tsx";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("缺少 #root 节点");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <PlatformProvider>
        <App />
      </PlatformProvider>
    </BrowserRouter>
  </StrictMode>,
);
